module.exports = __webpack_public_path__ + "static/media/2_10.6d01c995.png";